import { render, staticRenderFns } from "./workflow_palette.vue?vue&type=template&id=81aad9de&scoped=true&"
import script from "./workflow_palette.vue?vue&type=script&lang=js&"
export * from "./workflow_palette.vue?vue&type=script&lang=js&"
import style0 from "./workflow_palette.vue?vue&type=style&index=0&id=81aad9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aad9de",
  null
  
)

/* custom blocks */
import block0 from "./workflow_palette.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports